// extracted by mini-css-extract-plugin
export var card = "_jv-5";
export var cardSelected = "_jv-4";
export var image = "_jv-3";
export var modal = "_jv-0";
export var modalContent = "_jv-1";
export var table = "_jv-2";